import { NavLink, Outlet } from "react-router-dom"

export default function HelpLayout() {
  return (
    <div className="container help-layout" dir="rtl">

      <h2>ارشادات و نصائح </h2>
      <h4>الاختبار النظري: كل ما تحتاج لمعرفته حول الاختبار النظري </h4>
    <p > لتسهيل الأمر عليك ، قمنا بجمع كل المعلومات ذات الصلة حول الاختبار النظري وقمنا بتجميعها جميعًا هنا.</p>

      <nav>
        <NavLink to="faq">أسئلة شائعة </NavLink>
        <NavLink to="tips">نصائح </NavLink>
        {/* <NavLink to="#">تواصل معنا </NavLink> */}
      </nav>

      <Outlet />

    </div>
  )
}
